import { LitElement, html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";

import "@phosphor-icons/webcomponents/PhCaretDown";

import { styles } from "./collapsible-section.css";

@customElement("wow-collapsible-section")
export class CollapsibleSection extends LitElement {
  static override styles = styles;

  @property({ type: String })
  header = "";

  @property({ type: String })
  subtitle = "";

  @property({ type: Boolean, reflect: true })
  collapsible = false;

  @property({ type: Boolean, reflect: true })
  expanded = false;

  private toggleExpanded() {
    if (!this.collapsible) return;
    this.expanded = !this.expanded;
  }

  private renderSubtitle() {
    if (!this.subtitle) return nothing;
    return html`<p class="section-subtitle">${this.subtitle}</p>`;
  }

  override render() {
    if (!this.header) {
      return html`<slot></slot>`;
    }

    if (!this.collapsible) {
      return html`
        <div class="section">
          <h2 class="section-title">${this.header}</h2>
          ${this.renderSubtitle()}
          <div class="section-content">
            <slot></slot>
          </div>
        </div>
      `;
    }

    return html`
      <div class="section">
        <button class="collapsible-header" @click=${this.toggleExpanded} aria-expanded=${this.expanded}>
          <div class="header-text">
            <h2 class="section-title">${this.header}</h2>
            ${this.renderSubtitle()}
          </div>
          <ph-caret-down size="20" weight="bold" class="toggle-icon ${this.expanded ? "expanded" : ""}"></ph-caret-down>
        </button>
        <div class="collapsible-content ${this.expanded ? "expanded" : ""}">
          <slot></slot>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "wow-collapsible-section": CollapsibleSection;
  }
}
